import { Button, Modal } from '@mantine/core'
import { IconCaretRight } from '@tabler/icons'
import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'

const buttonStyles = {
  backgroundColor: '#4A1BD0',
  fontSize: '10px',
  width: 'auto',
  alignSelf: 'center'
}

const VideoOverlay = ({ videoKey }) => {
  const [videoError, setVideoError] = useState(false)

  const handleVideoError = () => {
    setVideoError(true)
  }

  if (videoError) {
    return null
  }

  return (
    <iframe
      width="560"
      height="315"
      src={`https://www.youtube.com/embed/${videoKey}`}
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      frameBorder={0}
      onError={handleVideoError}
    ></iframe>
  )
}

VideoOverlay.propTypes = {
  videoKey: PropTypes.string.isRequired
}

const TrailerButton = ({ videoKey, blur }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [videoExists, setVideoExists] = useState(true)

  useEffect(() => {
    fetch(
      `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoKey}&format=json`
    )
      .then((response) => {
        if (!response.ok) {
          setVideoExists(false)
        }
      })
      .catch(() => {
        setVideoExists(false)
      })
  }, [videoKey])

  const handleButtonClick = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  if (!videoExists) {
    return null
  }

  return (
    <>
      {/* <ActionIcon
        sx={{
          position: "absolute",
          bottom: "15px",
          right: "36px",
          boxShadow: "0px 0px 4px 1px rgba(255, 255, 190, .75)",
        }}
        size="xl"
        variant="outline"
        radius="xl"
        onClick={handleButtonClick}
      >
        <IconCaretRight size={40} fill="#adb5bd" />
      </ActionIcon> */}
      <Button
        sx={(theme) => ({
          ...buttonStyles,
          backgroundColor: '#7B39B6',
          width: '100%',
          transition: 'box-shadow 0.2s ease',
          '&:hover': {
            boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.2)',
            backgroundColor: theme.fn.darken('#7B39B6', 0.1)
          },
          '&:active': {
            boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.3)'
          }
        })}
        leftIcon={<IconCaretRight size={12} fill="white" />}
        onClick={handleButtonClick}
        mt={blur ? '17px' : '-20px'}
        mb={20}
        color="gray.0"
        size="xs"
      >
        TRAILER
      </Button>

      <Modal
        opened={isOpen}
        onClose={handleClose}
        size="auto"
        padding={0}
        withCloseButton={false}
        centered
      >
        <VideoOverlay videoKey={videoKey} />
      </Modal>
    </>
  )
}

TrailerButton.propTypes = {
  videoKey: PropTypes.string.isRequired
}

export default TrailerButton
